module.exports = __webpack_public_path__ + "img/2-2.6af89274.svg";